import { PlacementTask } from 'enums';
import { BasePlacementTaskItem } from './BasePlacementTaskItem';
import { RemarketingPlacementTaskItem } from './RemarketingPlacementTaskItem';
import { PlacementTaskItemProps } from './types';

export function PlacementTaskItem(props: PlacementTaskItemProps) {
  const { task } = props;

  switch (task.placementTask) {
    case PlacementTask.Remarketing:
      return <RemarketingPlacementTaskItem {...props} />;
    default:
      return <BasePlacementTaskItem {...props} />;
  }
}
